import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api.js";
import type { JSX } from "react";

export function RegisterGateway(): JSX.Element {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .listRegisters()
      .then((regs) => {
        const first = regs[0];
        if (first !== undefined) {
          void navigate(`/r/${first.registerId}`, { replace: true });
        } else {
          return api.createRegister("Demo register").then((reg) => {
            void navigate(`/r/${reg.registerId}`, { replace: true });
          });
        }
      })
      .catch((err: unknown) => setError(err instanceof Error ? err.message : String(err)));
  }, [navigate]);

  if (error !== null) {
    return (
      <div className="error" data-testid="gateway-error">
        {error}
      </div>
    );
  }

  return (
    <p className="muted" style={{ padding: "2rem 0" }}>
      Setting up your register...
    </p>
  );
}
